export const applyWppkProductSelection = ({
	rawData,
	selectedProducts,
	products,
	setChartData,
	mapData,
}) => {
	if (!rawData) {
		return;
	}

	const selectedIds = selectedProducts.map((selected) => selected.value);

	mapData(
		rawData,
		setChartData,
		products.filter((product) => selectedIds.includes(product._id)),
	);
};
